import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMutation, useLazyQuery } from '@apollo/client';
import { GET_ALL_DESIGNS, } from '../../Apollo/graphql/Query/getDesigns';
import { DELETE_DESIGN, EDIT_DESIGN } from '../../Apollo/graphql/Mutation/DesignsMutations';
import { Form, Input, Modal, Select, Spin, Table, Image, Typography, Switch } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { AlignType } from 'rc-table/lib/interface'
import { fallBackImage } from '../../utils/utilsFunctions';
// import Img3D from '../Model3D';

const { Option } = Select;

const DesignContainer = styled.div`

`
const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
// const BoxImage = styled.img`
//     height: inherit;
//     max-height: 100px;
//     width: auto;
// `

// const image3dStyle = {
//     top: 0,
//     right: 0,
//     alignItems: 'center',
//     height: '250px',
//     width: '100%'
// }

const DesignLists: FC = () => {
    const history = useHistory();
    const [designs, setDesigns] = useState();
    const [isEditing, setIsEditing] = useState(false);
    const [editingDesign, setEditingDesign] = useState<any>({});
    const [totalPage, setTotalPage] = useState<any>(1);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [filterValue, setFilterValue] = useState<any>();
    const [sortValue, setSortValue] = useState<any>({});
    const PAGE_LIMIT = 10;


    const [getDesigns, { loading, data, refetch }] = useLazyQuery(GET_ALL_DESIGNS, {
        onCompleted: (data) => {
            setDesigns(data?.designs?.designs);
            setTotalPage(data?.designs?.pagination?.total);
        },
        onError: (err) => {
            console.log(err);
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    })

    useEffect(() => {
        const variables = {};
        variables['pagination'] = {
            page: currentPage,
            limit: PAGE_LIMIT
        }
        if (filterValue !== 'ALL' || filterValue !== "") {
            variables['filter'] = {
                marketPlaceType: filterValue
            }
        }
        if (sortValue.value === 'asc' || sortValue.value === 'desc') {
            variables['sort'] = {
                price: sortValue.value
            }
        }
        if (sortValue.value === 'popular') {
            variables['sort'] = {
                popularity: 'desc'
            }
        }
        getDesigns({ variables: { ...variables } });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValue, currentPage, sortValue.value])

    const [editDesignMutation] = useMutation(EDIT_DESIGN, {
        onCompleted: data => {
            refetch && refetch();
        },
    });
    const [deleteDesignMutation] = useMutation(DELETE_DESIGN, {
        onCompleted: data => {
            refetch && refetch();
        },
    })

    const columns: any = [
        // { title: "ID", dataIndex: "_id", key: "_id" },
        {
            title: "Design", dataIndex: "", key: "featuredImage", align: 'center' as AlignType, width: '150px', render: (record: any) => {
                return (
                    // <Popover content={() => preview3dModal(record)}>
                    <Image
                        alt={record.name}
                        src={record.featuredImage || fallBackImage}
                        fallback={fallBackImage}
                        preview={false}
                        onClick={() => history.push(`/design/${record._id}`)}
                    />
                    // </Popover>
                )
            }
        },
        { title: "Design name", dataIndex: "name", align: 'center' as AlignType, key: "name" },
        {
            title: "MarketPlaceType", dataIndex: "marketPlaceType", align: 'center' as AlignType, key: "marketPlaceType",
            // filters: [{ text: "Paid", value: 'PAID' }, { text: "free", value: 'FREE' }],
            // filterMode: 'tree',
            // onFilter: (value: string, record: any) => {
            //     getDesigns({
            //         variables: {
            //             pagination: {
            //                 page: currentPage,
            //                 limit: PAGE_LIMIT
            //             },
            //             filter: {
            //                 marketPlaceType: value
            //             }
            //         }
            //     })
            // }
        },
        {
            title: "Price (AUD)", dataIndex: "price", align: 'center' as AlignType, key: "price",
            // sorter: (a, b) => a.price - b.price
        },
        { title: "Owned By", dataIndex: "", align: 'center' as AlignType, key: "ownedBy", render: (record: any) => (<Typography.Text>{record.owner?.firstName}</Typography.Text>) },
        {
            title: "Action",
            dataSource: "",
            key: "",
            align: 'center' as AlignType,
            render: (record: any) => {
                return <>
                    {/* <EyeOutlined onClick={() => DesignInfo(record)} /> */}
                    <EditOutlined onClick={() => onEditDesign(record)} style={{ color: "green" }} />
                    <DeleteOutlined onClick={() => onDeleteDesign(record)} style={{ color: "red", marginLeft: '1rem' }} />
                </>
            }
        }
    ]

    const onDeleteDesign = (record: any) => {
        Modal.confirm({
          title:
            "Are you sure to delete this Design? All orders related to this printer may appear empty.",
          okText: "Yes",
          okType: "danger",
          onOk: () => {
            deleteDesignMutation({
              variables: {
                designId: record._id,
              },
            });
          },
        });
    }
    const onEditDesign = (record: any) => {
        setIsEditing(true);
        setEditingDesign({ ...record });
    }
    const resetEditing = () => {
        setIsEditing(false);
        setEditingDesign({});
    }

    return (
        <Spin spinning={loading}>
            <DesignContainer>
                {data &&
                    <Table
                        bordered
                        title={() =>
                            <div style={{ display: 'flex', flexFlow: 'row', justifyContent: 'space-between' }}>
                                <Select
                                    placeholder={filterValue || 'Filter By'}
                                    dropdownMatchSelectWidth={false}
                                    onChange={(value) => {
                                        setCurrentPage(1);
                                        setFilterValue(value);
                                    }}
                                >
                                    <Option value="ALL">ALL </Option>
                                    <Option value="FREE">FREE</Option>
                                    <Option value="PAID">PAID</Option>
                                    <Option value="PRIVATE">PRIVATE</Option>
                                </Select>
                                <Select
                                    placeholder={sortValue?.children || 'Sort By'}
                                    dropdownMatchSelectWidth={false}
                                    onChange={(value, ch) => {
                                        setSortValue(ch)
                                    }}
                                >
                                    <Option value="popular">Popular</Option>
                                    <Option value="recent">Recent</Option>
                                    <Option value="desc">Price - High to Low</Option>
                                    <Option value="asc">Price - Low to High</Option>
                                </Select>
                            </div>
                        }
                        columns={columns}
                        dataSource={designs}
                        pagination={{
                            position: ['bottomCenter'],
                            current: currentPage,
                            total: totalPage,
                            showSizeChanger: false,
                            defaultPageSize: PAGE_LIMIT,
                            onChange: (page) => {
                                setCurrentPage(page);
                            }
                        }}
                    >
                    </Table>
                }
                <Modal
                    title="Edit Design"
                    okText="Save"
                    visible={isEditing}
                    onCancel={() => {
                        resetEditing();
                    }}
                    onOk={() => {
                        editDesignMutation({
                            variables: {
                                designId: editingDesign._id,
                                input: {
                                    name: editingDesign.name
                                }
                            },
                            refetchQueries: [{ query: GET_ALL_DESIGNS }]
                        })
                        resetEditing();
                    }}
                >
                    <MainContainer>
                        <div>
                            <img src={editingDesign?.design} alt="" />
                        </div>
                        <Form style={{ width: '100%' }}
                            labelCol={{ span: 24 }}
                        >
                            <Form.Item
                                label="Name"
                            >
                                <Input
                                    disabled
                                    value={editingDesign?.name}
                                    onChange={(e) => {
                                        setEditingDesign((pre) => {
                                            return { ...pre, name: e.target.value }
                                        })
                                    }}

                                />
                            </Form.Item>
                            <Form.Item
                                label="MarketPlaceType"
                            >
                                <Select
                                    disabled
                                    value={editingDesign?.marketPlaceType}
                                    onChange={(e) => {
                                        setEditingDesign((pre) => {
                                            return { ...pre, marketPlaceType: e }
                                        })
                                    }}
                                >
                                    <Option value="FREE">FREE</Option>
                                    <Option value="PAID">PAID</Option>
                                    <Option value="PRIVATE">PRIVATE</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Status"
                                name='status'
                            >
                                <Switch
                                    checkedChildren="active"
                                    unCheckedChildren="inactive"
                                    defaultChecked={editingDesign?.active}
                                    onChange={(e) => {
                                        setEditingDesign((pre) => {
                                            return { ...pre, active: e }
                                        })
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                label="description"
                            >
                                <Input
                                    disabled
                                    value={editingDesign?.description}
                                    onChange={(e) => {
                                        setEditingDesign((pre) => {
                                            return { ...pre, description: e.target.value }
                                        })
                                    }}

                                />
                            </Form.Item>
                        </Form>

                    </MainContainer>
                </Modal>
            </DesignContainer>
        </Spin>
    )
}

export default DesignLists;